var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-fluid" }, [
    _vm.label.title
      ? _c(
          "div",
          {
            staticClass:
              "row border-radius d-flex align-items-center bg-secondary-5 p-2"
          },
          [
            _vm.icon
              ? _c("icon", {
                  staticClass: "mx-3",
                  attrs: { i: _vm.icon.header }
                })
              : _vm._e(),
            _c("span", [_vm._v(_vm._s(_vm.label.title))])
          ],
          1
        )
      : _vm._e(),
    _c(
      "div",
      { staticClass: "row m-4" },
      _vm._l(_vm.selectedItems, function(item) {
        return _c("chip", {
          key: item.label,
          attrs: { "has-icon": false, title: item.label }
        })
      }),
      1
    ),
    !_vm.readOnly
      ? _c(
          "div",
          { staticClass: "row d-flex justify-content-center" },
          [
            !_vm.opened
              ? _c("open-btn", {
                  attrs: { text: _vm.label.openMsg },
                  on: {
                    click: function($event) {
                      _vm.opened = true
                    }
                  }
                })
              : _vm._e(),
            _vm.opened
              ? _c(
                  "div",
                  { staticClass: "col-12 mb-3 mt-2" },
                  [
                    _vm.icon.inside
                      ? _c("div", { staticClass: "ml-4" }, [
                          _c("em", {
                            staticClass:
                              "rounded-circle p-2 mr-2 color-green shadow bg-white",
                            class: _vm.icon.inside
                          }),
                          _c("span", [_vm._v(_vm._s(_vm.label.text))])
                        ])
                      : _vm._e(),
                    _c("container", {
                      staticClass: "mt-3",
                      attrs: {
                        label: _vm.label.inner,
                        "list-items": _vm.list.concat(_vm.selectedItems)
                      },
                      model: {
                        value: _vm.listSelected,
                        callback: function($$v) {
                          _vm.listSelected = $$v
                        },
                        expression: "listSelected"
                      }
                    }),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col d-flex justify-content-end" },
                        [
                          _c("action-button", {
                            staticClass: "mr-3",
                            attrs: {
                              i: "fas fa-times-circle",
                              text: "Cancelar",
                              variant: "outline-danger"
                            },
                            on: {
                              click: function($event) {
                                _vm.opened = false
                              }
                            }
                          }),
                          _c("action-button", {
                            attrs: {
                              i: "fas fa-plus",
                              text: "Añadir",
                              variant: "success"
                            },
                            on: { click: _vm.saveHandler }
                          })
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }